import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getcompetitionSlice = createSlice({
    name: 'competition',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchcompetition.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchcompetition.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchcompetition.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setcompetition, setStatus } = getcompetitionSlice.actions;
export default getcompetitionSlice.reducer;

export const fetchcompetition = createAsyncThunk('/competition-v2/public/fetch', async ({ currentPage = 1, postsPerPage = 10 } = {}) => {
    const res = await axios.get(`${getBaseUrl()}/competition-v2/public?page=${currentPage}&size=${postsPerPage}`);
    const competitionData = res.data;
    return competitionData;
})